enum CareType {
  BABYSITTER = 'BABYSITTER',
  NANNY = 'NANNY',
  HOUSEKEEPING = 'HOUSEKEEPING',
  PET_CARE = 'PET_CARE',
  SPECIAL_NEEDS = 'SPECIAL_NEEDS',
  COMPANION_CARE = 'COMPANION_CARE',
}

export { CareType };
